import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WPS_ENDPOINT } from '../shared/environment';

export interface ValidatePasswordResetResponse {
	email: string;
}

export interface ConfirmPasswordResetResponse {
	message: string;
}

@Injectable({
	providedIn: 'root',
})
export class PasswordResetService {
	private http = inject(HttpClient);

	private readonly HTTP_PROTOCOL = WPS_ENDPOINT.includes('localhost') ? 'http' : 'https';
	private readonly API_BASE_URL = `${this.HTTP_PROTOCOL}://${WPS_ENDPOINT}`;

	public async validateCode(code: string): Promise<ValidatePasswordResetResponse> {
		return new Promise((res, rej) => {
			this.http.post<ValidatePasswordResetResponse>(`${this.API_BASE_URL}/auth/reset-password/validate`, { code }, { observe: 'response' }).subscribe({
				next: (response) => {
					res(response.body as ValidatePasswordResetResponse);
				},
				error: (error: HttpErrorResponse) => {
					rej(this.parseError(error));
				},
			});
		});
	}

	public async confirmReset(code: string, newPassword: string): Promise<ConfirmPasswordResetResponse> {
		return new Promise((res, rej) => {
			this.http.post<ConfirmPasswordResetResponse>(`${this.API_BASE_URL}/auth/confirm-password-reset`, { code, newPassword }, { observe: 'response' }).subscribe({
				next: (response) => {
					res(response.body as ConfirmPasswordResetResponse);
				},
				error: (error: HttpErrorResponse) => {
					rej(this.parseError(error));
				},
			});
		});
	}

	private parseError(error: HttpErrorResponse): string {
		const body = error.error;

		if (typeof body === 'string' && body.trim()) return body.trim();
		if (body && typeof body === 'object' && typeof body.error === 'string' && body.error.trim()) return body.error.trim();

		return 'unexpected_error';
	}
}
